import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import vuetify from "@/plugins/vuetify";
import store from "@/store";
import "@/plugins/tt.js";
import i18n from "@/plugins/i18n.js";
import "@/plugins/auth0.js";
import "@/plugins/currency.js";
import "@/plugins/confirm.js";
import "@/plugins/vuetify-notify.js"
import "@/plugins/countryflag.js";
import "@/plugins/json-viewer.js";
import "@/plugins/language.js";
import "@/plugins/slideout.js"

Vue.config.productionTip = false;
new Vue({
  i18n,
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount("#app");
